const cleanMessage = {
  Id: '',
  Message: '',
  Username: '',
  WorkOrderId: 0,
  ReadDateTime: '',
  ReplyDateTime: '',
  Operator: '',
  MessageSource: ''
}
export default {
  messages: [],
  isTyping: false,
  chatHistory: [],
  directMessageCount: 0,
  cleanMessage: JSON.parse(JSON.stringify(cleanMessage)),
  files: [],
  channels: [],
  token: ''
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/state.js